export class DeeplinkConfig {
    displayStyle : any;
    linkLabel:string;
    selectType : string;
    embedMode: string;
}
